import { LoadablePaint } from '@confluence/loadable';

export const LazyNBMPerformanceReportPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NBMPerformanceReportPage" */ './NBMPerformanceReportPage.tsx'
			)
		).NBMPerformanceReportPage,
});
